var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 5.125C7.8642 4.95833 8.1358 4.95833 8.33333 5.125L12.7777 8.87497C13.0232 9.08208 13.073 9.47382 12.8889 9.74997C12.7048 10.0261 12.3565 10.0821 12.1111 9.87496L8 6.40624L3.88892 9.87496C3.64346 10.0821 3.29524 10.0261 3.11114 9.74997C2.92705 9.47382 2.9768 9.08208 3.22225 8.87497L7.66667 5.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpIcon);
export default __webpack_public_path__ + "static/media/chevron-up-icon.567d66fcd129a15dce3ccd5b12b8cb52.svg";
export { ForwardRef as ReactComponent };